module.exports = __webpack_public_path__ + "static/img/lbil_logo.c37b5950.png";